// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"00fcee1e","977":"e054bcf1"}[chunkId] + ".chunk.js";
};